<svelte:options customElement={{
  tag: 'code-block',
  shadow: 'none'
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * パーツライブラリ（/parts/）専用のコードブロック表示コンポーネント。
   * 子要素として渡された <pre><code>...</code></pre> を取り込み、
   * partspage-code-container-wrap 構造でラップしつつコピーボタンを付与する。
   *
   * 使い方:
   *   <code-block>
   *     <pre><code>&lt;div&gt;...&lt;/div&gt;</code></pre>
   *   </code-block>
   *
   * 注意:
   *   - shadow: 'none' のため <slot> は使わず onMount で host の子ノードを移動する
   *   - ビルド時は vite.config.js の transformWrapperElements() がタグを
   *     プレーン HTML に変換する（同等の DOM 構造を生成）
   *   - クリック時のコピー処理は initializers.js のグローバル委任が担当する
   */

  let wrapperEl;
  let containerEl;

  onMount(() => {
    if (!wrapperEl) return;
    const host = wrapperEl.parentElement;
    if (!host) return;

    // host 直下の <pre>（テンプレートで書かれたコード本体）を container に移動
    const pre = host.querySelector(':scope > pre');
    if (pre) {
      containerEl.appendChild(pre);
    }
  });
</script>

<div class="partspage-code-container-wrap" bind:this={wrapperEl}>
  <button type="button" class="partspage-code-btn" aria-label="コードをコピー">コピー</button>
  <div class="partspage-code-container" bind:this={containerEl}></div>
</div>
